import './Contacts.css';
import man1 from './contact.png';
import linkedin from './linkedin.png';
import github from './github.png';
import gmail from './gmail.png';
import leetcode from './leetcode.svg';
function Contacts(props) {
  return (
    <div className="contacts">
      <div className='upper-contact'>
        <div className="contact-image">
          <img src={man1} alt="sad?" />
        </div>
        <div className="contact-content">
          <h1>Reach Out to Me</h1>
          <br />
          <br />
          <p>{props.alldata[0].contact_desp}</p>
          <br />
          <br />
          <div className='logo'>
            <a href={props.alldata[0].linkedin_link}><img src={linkedin} alt="sad?" /></a>
            <a href={props.alldata[0].github_link} className='git'><img src={github} alt="sad?" /></a>
            <a href={`mailto:${props.alldata[0].gmail_link}`}><img src={gmail} alt="sad?" /></a>
            <a href={props.alldata[0].leetcode_link}><img src={leetcode} alt="sad?" /></a>
          </div>
        </div>
      </div>
      <div className='footer'>
        <footer>
          <p>{props.alldata[0].last}</p>
        </footer>
      </div>
    </div>
  );
}

export default Contacts;